import { forwardRef } from "react";
import VoiceTextarea from "./VoiceTextarea";

/**
 * Drop-in <textarea> with dictation (Voice Dictation contract §13).
 * Same API as a native textarea: onChange gets an event-like `{ target: { value } }`.
 * Dictated text is APPENDED to what's already typed, never replaces it.
 */
const DictTextarea = forwardRef(function DictTextarea(
  { value, onChange, className = "", rows = 3, voiceContext = "general", "data-testid": tid, ...rest }, ref,
) {
  const emit = (v) => onChange?.({ target: { value: v }, currentTarget: { value: v } });
  // Outer margins belong on the wrapper, or the mic floats below the box.
  const margins = className.split(/\s+/).filter((c) => /^-?m[trblxy]?-/.test(c));
  const inner = className.split(/\s+/).filter((c) => !margins.includes(c)).join(" ");
  const wrap = [/\bflex-1\b/.test(className) ? "flex-1 min-w-0" : "", ...margins].join(" ");
  return (
    <VoiceTextarea
      value={value}
      onChange={emit}
      onCommit={({ refined }) => {
        const cur = (value || "").trimEnd();
        emit(cur ? `${cur}\n${refined}` : refined);
      }}
      rows={rows}
      baseClass="w-full"
      className={inner}
      wrapperClassName={wrap}
      context={voiceContext}
      testIdPrefix={tid ? `${tid}-voice` : "dict-voice"}
      data-testid={tid}
      inputRef={ref}
      {...rest}
    />
  );
});

export default DictTextarea;
